import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Tabs, Tab } from "@mui/material";
import { TabContext } from "@mui/lab";
import { TabPanel } from "@mui/lab";
import Box from "@mui/material/Box";
import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import { restPostApi } from "../../services/httpService";
import {
  AUCTION_TAB,
  CODE_TAB,
  MONTHLY,
  PACKAGE_TAB,
  PRIZE_TAB,
} from "../../common/constant";
import { error, httpSuccess, success } from "../../common/errorCode";
import { isNotNull } from "../../common/utils";
import { loadHistoryDataUrl, loadHomeDataUrl } from "../../common/url";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HistoryPage = () => {
  const tokenInfo = useSelector((state) => state.SessionReducer);

  const [selectTab, setSelectTab] = React.useState(AUCTION_TAB);
  const [tabData, setTabData] = React.useState([]);
  const [tabColumnData, setTabColumnData] = React.useState([]);
  const [totalRow, setTotalRow] = React.useState(100);
  const { t } = useTranslation();

  const { innerWidth: width, innerHeight: height } = window;

  const handleChange = (event, newValue) => {
    setSelectTab(newValue);
    loadData(newValue);
  };

  useEffect(() => {
    // load data
    loadData();
  }, []);

  async function loadData(tabChoose) {
    let res = await restPostApi(
      loadHistoryDataUrl,
      {
        pageNumber: 0,
        pageSize: 10,
        type: isNotNull(tabChoose) ? tabChoose : selectTab,
      },
      tokenInfo
    );

    console.log("res: " + JSON.stringify(res));

    let message = "";
    let errorCode = error;

    if (res != null) {
      console.log("status: " + res.status);

      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);

        errorCode = res.data.errorCode;
        if (res.data.errorCode === success) {
          console.log("tabChoose: " + tabChoose);

          if (!isNotNull(tabChoose) || tabChoose == AUCTION_TAB) {
            console.log("AUCTION_TAB result");

            let dataSets = res.data.data.auctionResList;
            console.log("dataSets: " + JSON.stringify(dataSets));

            let rowSet = [];
            if (isNotNull(dataSets) && dataSets.length > 0) {
              for (let i = 0; i < dataSets.length; i++) {
                rowSet.push({
                  id: i + 1,
                  col1: dataSets[i].type,
                  col2: dataSets[i].frameTime,
                  col3: dataSets[i].time,
                  col4: dataSets[i].auction,
                });
              }
            }
            let col1Width = (width - 20) * 0.3;
            let col2Width = (width - 20) * 0.5;
            let col3Width = (width - 20) * 0.3;
            let col4Width = (width - 20) * 0.3;
            setTabColumnData([
              { field: "col1", headerName: t("type"), width: col1Width },
              { field: "col2", headerName: t("frameTime"), width: col2Width },
              { field: "col3", headerName: t("time"), width: col3Width },
              { field: "col4", headerName: t("auctions"), width: col4Width },
            ]);
            setTabData(rowSet);
            setTotalRow(isNotNull(res.data.totalRow) ? res.data.totalRow : 100);
          } else if (tabChoose == PACKAGE_TAB) {
            console.log("PACKAGE_TAB result");

            let dataSets = res.data.data.packageResList;
            console.log("dataSets: " + JSON.stringify(dataSets));

            let rowSet = [];
            if (isNotNull(dataSets) && dataSets.length > 0) {
              for (let i = 0; i < dataSets.length; i++) {
                rowSet.push({
                  id: i + 1,
                  col1: i + 1,
                  col2: dataSets[i].date,
                  col3: dataSets[i].packageName,
                });
              }
            }
            let col1Width = (width - 20) * 0.2;
            let col2Width = (width - 20) * 0.5;
            let col3Width = (width - 20) * 0.3;
            setTabColumnData([
              { field: "col1", headerName: t("no"), width: col1Width },
              { field: "col2", headerName: t("date"), width: col2Width },
              { field: "col3", headerName: t("package"), width: col3Width },
            ]);
            setTabData(rowSet);
            setTotalRow(isNotNull(res.data.totalRow) ? res.data.totalRow : 100);
          } else if (tabChoose == PRIZE_TAB) {
            console.log("PRIZE_TAB result");
            let dataSets = res.data.data.prizeResList;
            console.log("dataSets: " + JSON.stringify(dataSets));

            let rowSet = [];
            if (isNotNull(dataSets) && dataSets.length > 0) {
              for (let i = 0; i < dataSets.length; i++) {
                rowSet.push({
                  id: i + 1,
                  col1: i + 1,
                  col2: dataSets[i].date,
                  col3: dataSets[i].type,
                  col4: dataSets[i].prize,
                });
              }
            }
            let col1Width = (width - 20) * 0.2;
            let col2Width = (width - 20) * 0.35;
            let col3Width = (width - 20) * 0.3;
            let col4Width = (width - 20) * 0.25;

            setTabColumnData([
              { field: "col1", headerName: t("no"), width: col1Width },
              { field: "col2", headerName: t("date"), width: col2Width },
              { field: "col3", headerName: t("type"), width: col3Width },
              { field: "col4", headerName: t("prize"), width: col4Width },
            ]);
            setTabData(rowSet);
            setTotalRow(isNotNull(res.data.totalRow) ? res.data.totalRow : 100);
          } else if (tabChoose == CODE_TAB) {
            console.log("CODE_TAB result");
            let dataSets = res.data.data.codeResList;
            console.log("dataSets: " + JSON.stringify(dataSets));

            let rowSet = [];
            if (isNotNull(dataSets) && dataSets.length > 0) {
              for (let i = 0; i < dataSets.length; i++) {
                rowSet.push({
                  id: i + 1,
                  col1: i + 1,
                  col2: dataSets[i].date,
                  col3: dataSets[i].monthDraw,
                  col4: dataSets[i].code,
                });
              }
            }
            let col1Width = (width - 20) * 0.2;
            let col2Width = (width - 20) * 0.45;
            let col3Width = (width - 20) * 0.35;
            let col4Width = (width - 20) * 0.25;

            setTabColumnData([
              { field: "col1", headerName: t("no"), width: col1Width },
              { field: "col2", headerName: t("date"), width: col2Width },
              { field: "col3", headerName: t("monthlyDraw"), width: col3Width },
              { field: "col4", headerName: t("code"), width: col4Width },
            ]);
            setTabData(rowSet);
            setTotalRow(isNotNull(res.data.totalRow) ? res.data.totalRow : 100);
          }
          return;
        } else {
          console.log("message: " + res.data.message);
          message = res.data.message;
          setTabData([]);
        }
      } else {
        console.log("message: " + res.data);
        message = res.data;
        setTabData([]);
      }
    } else {
      console.log("message: Exception");
      message = "Exception";
    }
    // store.dispatch(setDataToModal({
    //     type: 'result',
    //     dataToModal: {
    //         errorCode: errorCode,
    //         message: message
    //     }
    // }));
  }

  return (
    <div>
      <TabContext value={selectTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={selectTab}
            onChange={handleChange}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#F7BD08",
              },
            }}
          >
            <Tab
              className="tab-control"
              label={t("auction").toUpperCase()}
              value={AUCTION_TAB}
            />
            <Tab
              className="tab-control"
              label={t("package").toUpperCase()}
              value={PACKAGE_TAB}
            />
            <Tab
              className="tab-control"
              label={t("prize").toUpperCase()}
              value={PRIZE_TAB}
            />
            <Tab
              className="tab-control"
              label={t("code").toUpperCase()}
              value={CODE_TAB}
            />
          </Tabs>
        </Box>
        <TabPanel value={AUCTION_TAB}>
          <DataGrid
            disableColumnMenu
            rows={tabData}
            columns={tabColumnData}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            rowCount={parseInt(totalRow)}
            style={{ color: "white", border: "none" }}
            sx={{
              color: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "white",
              },
              "& .MuiTablePagination-displayedRows": {
                color: "white",
              },
              "& .MuiButtonBase-root": {
                color: "white !important",
              },
            }}
          />
        </TabPanel>
        <TabPanel value={PACKAGE_TAB}>
          <DataGrid
            disableColumnMenu
            rows={tabData}
            columns={tabColumnData}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            rowCount={totalRow}
            style={{ color: "white", border: "none" }}
            sx={{
              color: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "white",
              },
              "& .MuiTablePagination-displayedRows": {
                color: "white",
              },
              "& .MuiButtonBase-root": {
                color: "white !important",
              },
            }}
          />
        </TabPanel>
        <TabPanel value={PRIZE_TAB}>
          <DataGrid
            disableColumnMenu
            rows={tabData}
            columns={tabColumnData}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            rowCount={totalRow}
            style={{ color: "white", border: "none" }}
            sx={{
              color: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "white",
              },
              "& .MuiTablePagination-displayedRows": {
                color: "white",
              },
              "& .MuiButtonBase-root": {
                color: "white !important",
              },
            }}
          />
        </TabPanel>
        <TabPanel value={CODE_TAB}>
          <DataGrid
            disableColumnMenu
            rows={tabData}
            columns={tabColumnData}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            rowCount={totalRow}
            style={{ color: "white", border: "none" }}
            sx={{
              color: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "white",
              },
              "& .MuiTablePagination-displayedRows": {
                color: "white",
              },
              "& .MuiButtonBase-root": {
                color: "white !important",
              },
            }}
          />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default HistoryPage;
